export const AXIS_IDS = {
    xAxis0: 'x-axis-0',
    yAxis0: 'y-axis-0',
    yAxis1: 'y-axis-1'
};
